import { getAddrTreeAPI } from "@/apis/apt-api"
import dayjs from "dayjs"
import { create } from "zustand"
import { persist } from "zustand/middleware"

export const aptSearchStore = create(
  persist(
    (set) => ({
      addrTree: {},

      apiGetAddrTree: async () => {
        const addrTree = await getAddrTreeAPI()
        set({ addrTree })
      },

      pickApt: null,

      setPickApt: (apt) => {
        let pickApt = apt

        if (!apt.ended_at) {
          const today = dayjs().format("YYYY-MM-DD")
          pickApt = { ...apt, ended_at: apt.ended_at ?? today }
        }

        set({ pickApt })
      },

      setSearch: (selected, keyword) =>
        set({
          appliedSelected: selected,
          appliedKeyword: keyword
        }),

      resetSearch: () => set({ isOnlyFav: false }),

      pickReset: () => set({ pickApt: "" })
    }),
    {
      name: "mc-apt",

      partialize: (state) => ({
        pickApt: state.pickApt
      })
    }
  )
)
